import { Box, Card, useTheme } from '@material-ui/core'
import React, {useContext} from 'react'
import ManifestAddForm from './ManifestAddForm'
import Stepper from '../../../components/aciacehighway/Stepper'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import { useFormStyles } from 'src/common/FormStyles'
import clsx from 'clsx'
import SectionJumper from 'src/components/SectionJumper'
import ACEHighwayManifestTranslationText from './../contexts/ACEHighwayManifestTranslationText'

function AddPage({ history, showNotification, onSetLoading }) {
  const theme = useTheme()
  const formClass = useFormStyles()
  const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText() 

  return (
    <Card className={clsx(formClass.form, formClass.inputs)}>
      <Stepper steps={[aceHighwayManifestTranslationText.createTrip]} activeStep={0} />
      <Box padding={2}>
        <ManifestAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => console.log('submit success')}
          onSetLoading={onSetLoading}
        />
      </Box>
      <SectionJumper pages={[
        {
          label: aceHighwayManifestTranslationText.addManifest,
          sections: [
            {label: aceHighwayManifestTranslationText.tripInformation, id: 'trip-info'},
            {label: aceHighwayManifestTranslationText.truckConveyance, id: 'truck-conveyance'},
            {label: aceHighwayManifestTranslationText.equipmentInformation, id: 'eqp-info'},
            {label: aceHighwayManifestTranslationText.crewInformation, id: 'crew-info'},
            {label: aceHighwayManifestTranslationText.insuranceInformation, id: 'insurance-info'},
            {label: aceHighwayManifestTranslationText.messageFunction, id: 'msg-fn'},
          ]
        }
      ]} />
    </Card>
  )
}

export default withFormState(AddPage)
